import { mount } from '../../../js/dom-lifecycle';

mount('[data-progress-bar-refresh]', function () {
    setTimeout(() => {
        $.get(this.dataset.progressBarRefresh, data => $(this).replaceWith(data));
    }, 500);
});
